module.exports = {
  formatLocaleString: function(input) {
    let locale;
    if (input) {
      const localeString = input.replace('-', '_');
      const [language, region = ''] = localeString.split('_');
      locale = `${language.toLowerCase()}_${region.toUpperCase()}`;
    }
    return locale;
  }
};
